import { useState } from "react"
import { ChevronRightIcon } from "@heroicons/react/24/outline"

const DiscoverCollapsibleSection = ({
  title,
  default_open,
  children,
}) => {
  const [is_open, set_is_open] = useState(default_open === true)

  return (
    <div className="mt-6 rounded-lg border border-gray-200 bg-white">
      <div className="border-b border-gray-100 px-2 py-2">
        <button
          type="button"
          className="flex w-full items-center gap-2 rounded-md px-2 py-1.5 text-left hover:bg-gray-50"
          onClick={() => set_is_open(!is_open)}
          aria-expanded={is_open}
        >
          <ChevronRightIcon
            className={`h-5 w-5 shrink-0 text-gray-500 transition-transform duration-200 ${
              is_open ? "rotate-90" : "rotate-0"
            }`}
            aria-hidden
          />
          <span className="text-sm font-semibold text-gray-900">{title}</span>
        </button>
      </div>
      {is_open && (
        <div className="p-4">
          {children}
        </div>
      )}
    </div>
  )
}

export default DiscoverCollapsibleSection
